import {  database } from '../../firebase';

const GET_PETITION = '@DONACO/GET_PETITION';

const petitionsRef = database.ref('/petitions');

export const getPetitions = () => {
  return (dispatch) => {
    petitionsRef.once('value', (snapshot) => {
      const petitions = snapshot.val();
      dispatch({type: GET_PETITION, payload: petitions})
    })
  };
};
export const petitionReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PETITION:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

